<template>
  <component :is="layout">
    <RouterView v-slot="{ Component }">
      <Transition
        enterFromClass="opacity-0"
        enterActiveClass="transition duration-300"
      >
        <component :is="Component" />
      </Transition>
    </RouterView>
  </component>

  <AppToasts />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { FIREBASE_CONFIG } from '@/config/fcmTokens'
import AppToasts from '@/modules/Core/components/partials/AppToasts/AppToasts.vue'

defineOptions({
  name: 'TheAppLayout',
})

const route = useRoute()

const layout = computed(() => {
  const layout = route?.meta?.layout

  if (layout) {
    return `The${layout}Layout`
  }
  return 'div'
})

const firebaseApp = initializeApp(FIREBASE_CONFIG)

getAnalytics(firebaseApp)
</script>
